import Dashboard from "@/Pages/Dashboard.vue";
import UsersIndex from "@/Pages/Admin/Users/UsersIndex.vue";
import User from "@/Pages/Admin/Users/User.vue";
import UserForm from "@/Pages/Admin/Users/UserForm.vue";
import GroupsIndex from "@/Pages/Admin/Groups/GroupsIndex.vue";
import Group from "@/Pages/Admin/Groups/Group.vue";
import GroupForm from "@/Pages/Admin/Groups/GroupForm.vue";
import QuestionsIndex from "@/Pages/Admin/Questions/QuestionsIndex.vue";
import Question from "@/Pages/Admin/Questions/Question.vue";
import QuestionForm from "@/Pages/Admin/Questions/QuestionForm.vue";
import StimuliIndex from "@/Pages/Admin/Stimuli/StimuliIndex.vue";
import InvitationsIndex from "@/Pages/Admin/Invitations/InvitationsIndex.vue";
import PlansIndex from "@/Pages/Admin/Plans/PlansIndex.vue";
import Plan from "@/Pages/Admin/Plans/Plan.vue";
import PlanForm from "@/Pages/Admin/Plans/PlanForm.vue";
import TagsIndex from "@/Pages/Admin/Tags/TagsIndex.vue";
import AuditsIndex from "@/Pages/Admin/Audits/AuditsIndex.vue";
import SettingsIndex from "@/Pages/Admin/Settings/SettingsIndex.vue";
import Stimulus from "@/Pages/Admin/Stimuli/Stimulus.vue";
import ClientForm from "../Pages/Admin/Users/ClientForm.vue";
import AiPromptsIndex from "@/Pages/Admin/AiPrompts/AiPromptsIndex.vue";
import AiPromptForm from "@/Pages/Admin/AiPrompts/AiPromptForm.vue";

export default [
    {
        path: "",
        component: Dashboard,
        name: "admin.dashboard",
    },
    // Users
    {
        path: "users",
        component: UsersIndex,
        name: "admin.users.index",
    },
    {
        path: "users/:user",
        component: User,
        name: "admin.users.show",
    },
    {
        path: "users/create",
        component: UserForm,
        name: "admin.users.create",
    },
    {
        path: "users/:user/edit",
        component: UserForm,
        name: "admin.users.edit",
    },
    {
        path: "clients/create",
        component: ClientForm,
        name: "admin.clients.create",
    },
    // Groups
    {
        path: "groups",
        component: GroupsIndex,
        name: "admin.groups.index",
    },
    {
        path: "groups/:group",
        component: Group,
        name: "admin.groups.show",
    },
    {
        path: "groups/create",
        component: GroupForm,
        name: "admin.groups.create",
    },
    {
        path: "groups/:group/edit",
        component: GroupForm,
        name: "admin.groups.edit",
    },
    //     Questions
    {
        path: "questions",
        component: QuestionsIndex,
        name: "admin.questions.index",
    },
    {
        path: "questions/:question",
        component: Question,
        name: "admin.questions.show",
    },
    {
        path: "questions/create",
        component: QuestionForm,
        name: "admin.questions.create",
    },
    {
        path: "questions/:question/edit",
        component: QuestionForm,
        name: "admin.questions.edit",
    },
    // Stimuli
    {
        path: "stimuli",
        component: StimuliIndex,
        name: "admin.stimuli.index",
    },
    {
        path: "stimuli/:stimulus",
        component: Stimulus,
        name: "admin.stimuli.show",
    },
    // Invitations
    {
        path: "invitations",
        component: InvitationsIndex,
        name: "admin.invitations.index",
    },
    // Plans
    {
        path: "plans",
        component: PlansIndex,
        name: "admin.plans.index",
    },
    {
        path: "plans/:plan",
        component: Plan,
        name: "admin.plans.show",
    },
    {
        path: "plans/create",
        component: PlanForm,
        name: "admin.plans.create",
    },
    {
        path: "plans/:plan/edit",
        component: PlanForm,
        name: "admin.plans.edit",
    },
    // Tags
    {
        path: "tags",
        component: TagsIndex,
        name: "admin.tags.index",
    },
    // Audits
    {
        path: "audits",
        component: AuditsIndex,
        name: "admin.audits.index",
    },
    // Settings
    {
        path: "settings",
        component: SettingsIndex,
        name: "admin.settings.index",
    },
    // AI Prompts
    {
        path: "ai-prompts",
        component: AiPromptsIndex,
        name: "admin.ai-prompts.index",
    },
    {
        path: "ai-prompts/create",
        component: AiPromptForm,
        name: "admin.ai-prompts.create",
    },
    {
        path: "ai-prompts/:aiPrompt/edit",
        component: AiPromptForm,
        name: "admin.ai-prompts.edit",
    },
];
